import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInMonths,
  differenceInWeeks,
  differenceInYears,
} from 'date-fns'

export const getDateDiffInDays = (start: Date, finish: Date) => {
  const diffTime = finish.getTime() - start.getTime();

  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

export const getDateDiffFormatted = (start: Date, finish: Date) => {
  const yearsDiff = differenceInYears(start, finish)
  const monthsDiff = differenceInMonths(start, finish)
  const weeksDiff = differenceInWeeks(start, finish)
  const daysDiff = differenceInDays(start, finish)
  const hoursDiff = differenceInHours(start, finish)
  const minutesDiff = differenceInMinutes(start, finish)

  if (yearsDiff > 0) {
    return `${yearsDiff} ${yearsDiff > 1 ? 'anos' : 'ano'}`
  }

  if (monthsDiff > 0) {
    return `${monthsDiff} ${monthsDiff > 1 ? 'meses' : 'mês'}`
  }

  if (weeksDiff > 0) {
    return `${weeksDiff} ${weeksDiff > 1 ? 'semanas' : 'semana'}`
  }

  if (daysDiff > 0) {
    return `${daysDiff} ${daysDiff > 1 ? 'dias' : 'dia'}`
  }

  if (hoursDiff > 0) {
    return `${hoursDiff} ${hoursDiff > 1 ? 'horas' : 'hora'}`
  }

  if (minutesDiff > 0) {
    return `${minutesDiff} ${minutesDiff > 1 ? 'minutos' : 'minuto'}`
  }

  return '< 1 minuto'
}
